const fromNumStringToUriEncoded = (c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;

const fromJwtToBase64 = (token) =>
  token
    .split('.')[1]
    .replace(/-/g, '+')
    .replace(/_/g, '/');

const fromBase64ToString = (base64) =>
  window
    .atob(base64)
    .split('')
    .map(fromNumStringToUriEncoded)
    .join('');

// @see https://stackoverflow.com/a/38552302
const parseJwt = (token) => {
  try {
    return JSON.parse(decodeURIComponent(fromBase64ToString(fromJwtToBase64(token))));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('parseJwt()', e, 'tried to parse:', token);
    return undefined;
  }
};

// noinspection JSUnusedGlobalSymbols
export default parseJwt;
